import Carousel from "./Carousel";
import TextCard from "./TextCard";
import Testimonials from "./Testimonials";
import { Columns, Container } from "react-bulma-components";
import Calendar from "./Calendar";
import { CenteredDivGrid } from "./Utilities";
import { useContext, useState } from "react";
import styled, { keyframes, ThemeContext } from "styled-components";

// const missionText =
//   config.quotes.generatedLong[
//     Math.floor(Math.random() * config.quotes.generatedLong.length)
//   ];
// const generatedShort = config.quotes.generatedShort.slice(0, 3).join(",");

//     <Container pt="4">
//       <Columns>
//         <Columns.Column size="three-fifths">
//           <TextCard
//             title="Xavier Lipton College"
//             text={missionText}
//             shakyProbability={0.0}
//           ></TextCard>
//         </Columns.Column>
//         <Columns.Column>
//           <TextCard
//             title="Our Specialties"
//             text={generatedShort}
//             shakyProbability={0.0}
//           ></TextCard>
//         </Columns.Column>
//       </Columns>
//     </Container>

const hrBackgroundGradientAnimation = keyframes`
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
`;
const StyledHr = styled.hr`
  height: 2px;
  background: linear-gradient(272deg, #f4c3e4, #a6bcc9, #c3dbc5);
  background-size: 800% 800%;

  animation: ${hrBackgroundGradientAnimation} 1s ease infinite;
`;

export function Home({ config, ...props }) {
  const theme = useContext(ThemeContext);
  const [missionText] = useState(
    config.quotes.generatedLong[
      Math.floor(Math.random() * config.quotes.generatedLong.length)
    ]
  );
  const generatedShort = config.quotes.generatedShort.slice(0, 3).join(",");

  const homeContent = (
    <Container>
      <Carousel carouselConfig={config.carousel}></Carousel>
      <Container pt="4" pb="6">
        <Columns>
          <Columns.Column size="three-fifths">
            <TextCard
              id="mission"
              title="Mission"
              text={missionText}
              shakyProbability={0.0}
            ></TextCard>
          </Columns.Column>
          <Columns.Column>
            <TextCard
              id="specialties"
              title="Our Specialties"
              text={generatedShort}
              shakyProbability={0.0}
            ></TextCard>
          </Columns.Column>
        </Columns>
      </Container>
      <CenteredDivGrid>
        <Calendar data={config.data}></Calendar>
      </CenteredDivGrid>
      <StyledHr bgColor={theme.componentBackground}></StyledHr>
      {/* <Testimonials quotes={config.quotes}></Testimonials> */}
    </Container>
  );
  return homeContent;
}

export default Home;
